import {setTheme} from '../v2/actions/theme-actions';
import store from '../v2/store/store';
import isCAAS from '../v2/utils/isCAAS';
import isLegacySite from '../v2/utils/isLegacySite';
import Track from '../v2/utils/tracking';
import buildThemeFromCore from './buildThemeFromCore';

export default () => {
  const {theme, themeObj, start} = window;
  const artemisTheme = themeObj?.theme;
  
  const artemisSettingeEnabled = start.settings?.artemis_integration_enabled;
  const isUsingArtemisStyles = !!(artemisSettingeEnabled && !isCAAS(start.siteDataV2.siteId)
    && !isLegacySite(start.siteDataV2.siteCode));
  
  if (isUsingArtemisStyles) {
    const builtTheme = buildThemeFromCore({}, artemisTheme, isUsingArtemisStyles);
    return store.dispatch(setTheme(builtTheme));
  }

  return import(
    /* webpackChunkName: "[request]-theme" */
    /* webpackExclude: /\.test\./ */
    // This can't be resolved yet due to a known issue with ESLint
    // See eg https://github.com/babel/babel-eslint/issues/799
    // eslint-disable-next-line prefer-template
    './sites/' + theme
  )
    .then((importedTheme) => {
      const builtTheme = buildThemeFromCore(importedTheme.default, artemisTheme, isUsingArtemisStyles);
      store.dispatch(setTheme(builtTheme));
    })
    .catch((error) => {
      Track.track(`Failed to load theme ${theme}. ${error}`);
    });
};
